module.exports = __webpack_public_path__ + "img/fcpa.c3359441.svg";